import { Domains } from 'context'
import { UserScrapType } from 'generated/graphql'
import { COMPANY_ANALYSIS } from '../mobile/screen/ScreenScrap.mobile'

export const getNoScrapMessage = (
  tabState: UserScrapType | typeof COMPANY_ANALYSIS,
  domains: Domains,
) => {
  switch (tabState) {
    case UserScrapType.ACTIVITY: {
      return {
        heading: {
          highlightText: '스크랩한 공고',
          text: '가 없습니다',
        },
        subText: '관심있는 공고를 확인해보시겠어요?',
        actions: [
          {
            name: '대외활동',
            link: '/list/activity',
          },
          {
            name: '공모전',
            link: '/list/contest',
          },
          {
            name: '동아리',
            link: '/list/club',
          },
          {
            name: '채용',
            link: '/list/recruit',
          },
          {
            name: '교육',
            link: '/list/education',
          },
        ],
      }
    }
    case UserScrapType.COVER_LETTER_AND_PARAGRAPH: {
      return {
        heading: {
          highlightText: '스크랩한 합격자소서나 문장',
          text: '이 없습니다',
        },
        subText: '합격자소서를 확인해보시겠어요?',
        actions: [
          {
            name: '합격자소서보기',
            link: '/cover-letter/search',
          },
        ],
      }
    }
    case UserScrapType.COVER_LETTER: {
      return {
        heading: {
          highlightText: '스크랩한 합격자소서',
          text: '가 없습니다',
        },
        subText: '합격자소서를 확인해보시겠어요?',
        actions: [
          {
            name: '합격자소서보기',
            link: '/cover-letter/search',
          },
        ],
      }
    }
    case UserScrapType.COVER_LETTER_PARAGRAPH: {
      return {
        heading: {
          highlightText: '스크랩한 문장',
          text: '이 없습니다',
        },
        subText: '합격자소서를 확인해보시겠어요?',
        actions: [
          {
            name: '합격자소서보기',
            link: '/cover-letter/search',
          },
        ],
      }
    }
    case UserScrapType.COMMUNITY: {
      return {
        heading: {
          highlightText: '스크랩한 게시글',
          text: '이 없습니다',
        },
        subText: '회원들의 실제 합격후기&인기글을 확인하시겠어요?',
        actions: [
          {
            name: 'Best 인기글',
            link: `//${domains.xen}/best`,
          },
          {
            name: '합격후기',
            link: `//${domains.xen}/hothot`,
          },
        ],
      }
    }
    case COMPANY_ANALYSIS: {
      return {
        heading: {
          highlightText: '스크랩한 기업분석자료',
          text: '가 없습니다',
        },
        subText: '기업, 산업 등 다양한 기업분석자료를 확인해보세요',
        actions: [
          {
            name: '분석자료 보러가기',
            link: `/company-analysis`,
          },
        ],
      }
    }
    default: {
      return {
        heading: {
          highlightText: '',
          text: '잘못된 요청입니다.',
        },
        subText: '',
        actions: [],
      }
    }
  }
}
